import React from "react";
import { StyledButton, Typography } from "./rounded-button.styled";

export default function RoundedButton({ onClickHandler, backgroundcolor, text }) {
    return (
        <StyledButton onClick={onClickHandler} backgroundcolor={backgroundcolor}>
            <Typography>{text}</Typography>
        </StyledButton>
    );
};
